import { Checkbox, useEventCallback } from '@mui/material';
import { FormControlLabel, Grid } from '@mui/material';
import { CommunicationVM, ViewStepVM } from 'civil-status/view-models/step-form';
import { FormikProps } from 'formik';
import { Fragment, memo, useMemo } from 'react';
import { CommunicationRes } from 'shell/models/communications';

interface typeList {
  id: keyof CommunicationVM;
  value: string;
}

interface ComunicationProps {
  formContext: FormikProps<ViewStepVM>;
  controlsCommunications?: Array<CommunicationRes>;
}

const ComunicationComponent = ({
  formContext,
  controlsCommunications,
}: ComunicationProps): React.ReactElement => {
  const checkboxList: Array<typeList> = useMemo(() => {
    const listRes: Array<typeList> = [];

    controlsCommunications?.forEach((element) => {
      listRes.push({
        id: element.templateComunicazioneVO?.codiceTemplateStampa || '',
        value: element.comunicazioneVO?.descComunicazione || '',
      } as typeList);
    });

    return listRes;
  }, [controlsCommunications]);

  const values = formContext.values.comunication || {};
  const onChange = useEventCallback((key?: string) => {
    formContext.setFieldValue('comunication', {
      elementSelected: key,
    });
  });

  return (
    <Fragment>
      <Grid item container spacing={2} xs={12}>
        {checkboxList.map((item) => {
          const currentKey = item.id;
          return (
            <Grid item xs={12} key={`key-${item.id}`}>
              <FormControlLabel
                control={
                  <Checkbox
                    id={`id-${item.id}`}
                    checked={values.elementSelected === currentKey}
                    onChange={() => {
                      onChange(currentKey);
                    }}
                    inputProps={{ 'aria-label': item.value }}
                  />
                }
                label={item.value}
              />
            </Grid>
          );
        })}
      </Grid>
    </Fragment>
  );
};

ComunicationComponent.displayName = 'Comunication Document from ANSC';

const Comunication = memo(ComunicationComponent);

export default Comunication;
